import React from 'react';
import PropTypes from 'prop-types';
import { getClassNames } from '../../../services/stylingUtils';

import styles from './styles.scss';

export default class FormButtonPanel extends React.Component {

    _getClassNames() {
        return getClassNames(styles, this.props.className, {
            'panel--bottom': this.props.position === 'bottom',
            'panel--top': this.props.position === 'top'
        });
    }

    render() {
        return (
            <div className={this._getClassNames()}>{ this.props.children }</div>
        )
    }
}

FormButtonPanel.defaultProps = {
    position: 'bottom'
};


FormButtonPanel.propTypes = {
    position: PropTypes.oneOf(['bottom', 'top'])
};